import Phaser from 'phaser';
import LevelSelectMenuPage from './LevelSelectMenuPage';
import ABCyaPhaser from '@abcya/abcya_phaser';
import gameData from '../gameData';

export default class LevelSelectMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} numberOfLevels
   */
  constructor(scene, numberOfLevels) {
    super(scene);

    this.curPageIndex = null;
    this.curPageShown = null;

    // create pages from all levels
    this.numPages = Math.ceil(numberOfLevels / 6);

    /** @type {LevelSelectMenuPage[]} */
    this.menuPages = [];
    let startMenuIndex = 0;
    while (this.menuPages.length < this.numPages) {
      const newPage = new LevelSelectMenuPage(this.scene, startMenuIndex);
      this.add(newPage);
      newPage.x = this.scene.scale.width;
      newPage.alpha = 0;
      this.menuPages.push(newPage);
      startMenuIndex += 6;
    }

    this.nextBtn = ABCyaPhaser.Images.addImage(0, this.scene.scale.width / 2 + 200, 'btn-arrow', this).setOrigin(0.5, 0)
      .setInteractive();

    this.backBtn = ABCyaPhaser.Images.addImage(0, this.scene.scale.width / 2 + 200, 'btn-arrow', this).setOrigin(0.5, 0)
      .setScale(-1, 1)
      .setInteractive();

    this.showMenuPage(0);
  }

  showMenuPage (showIndex) {
    if (showIndex !== this.curPageIndex) {
      this.hideBtns();
      const fromRight = !this.curPageIndex || this.curPageIndex < showIndex;

      if (this.curPageShown !== null) {
        // move right or left if new index is higher or lower
        const pageToRemove = this.curPageShown;
        pageToRemove.deinitPageButtons();
        pageToRemove.off('BTN_SELECT', this.handleLevelSelect, this);
        const pageEndX = fromRight ? -this.scene.scale.width : this.scene.scale.width;
        ABCyaPhaser.Tweens.addTween(pageToRemove, 500, { x: pageEndX, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
      }

      // start page from right or left depending on if last index is less or more than new
      this.curPageIndex = showIndex;
      this.curPageShown = this.menuPages[this.curPageIndex];
      this.curPageShown.x = fromRight ? this.scene.scale.width : this.scene.scale.width * -1;

      ABCyaPhaser.Tweens.addTween(this.curPageShown, 800, { x: 0, alpha: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out, () => this.showPageButtons());
    }
  }

  showPageButtons () {
    this.nextBtn.alpha = this.curPageIndex < this.numPages - 1 ? 1 : 0;
    if (this.nextBtn.alpha > 0) this.nextBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.handlePageChange(this.nextBtn));
    this.backBtn.alpha = this.curPageIndex > 0 ? 1 : 0;
    if (this.backBtn.alpha > 0) this.backBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.handlePageChange(this.backBtn));

    if (this.curPageIndex > 0 && this.curPageIndex < this.numPages - 1) {
      // both back and next
      this.backBtn.x = this.scene.scale.width / 4;
      this.nextBtn.x = (this.scene.scale.width / 4) * 3;
    }
    else if (this.curPageIndex > 0) {
      // just back
      this.backBtn.x = (this.scene.scale.width / 4) * 3;
    }
    else {
      this.nextBtn.x = (this.scene.scale.width / 4) * 3;
    }

    this.curPageShown.initPageButtons();
    this.curPageShown.inputReady = true;
    this.curPageShown.on('BTN_SELECT', this.handleLevelSelect, this);
  }

  hideBtns () {
    if (this.nextBtn.alpha > 0) {
      this.nextBtn.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.nextBtn.alpha = 0;
    }

    if (this.backBtn.alpha > 0) {
      this.backBtn.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      this.backBtn.alpha = 0;
    }
  }

  handlePageChange (btn) {
    ABCyaPhaser.Audio.playOneShot('menu-button-click', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);
    const newIndex = btn === this.backBtn ? this.curPageIndex - 1 : this.curPageIndex + 1;
    this.showMenuPage(newIndex);
  }

  handleLevelSelect (args) {
    this.curPageShown.inputReady = false;
    this.emit('LEVEL_SELECTED', { _selectedLevelIndex: args._btnId });
  }
}